import { createConfigTabCacheKeys } from "features/shared/lib/technical-config-tab/api/cacheKeys";

const ROOT = "windowConfigTab" as const;

export const WINDOW_CONFIG_CACHE_KEYS = {
  ...createConfigTabCacheKeys(ROOT),
  catalog: [ROOT, "windowCatalog"] as const,
  shadingCatalog: (windowTypeDbId?: number) => [ROOT, "shadingCatalog", windowTypeDbId] as const,
};
